<script setup lang="ts">
import { useNuxtApi } from '@/composables/useNuxtApi'

import TheNewsList from '@/components/News/TheNewsList.vue'

import type { MainPageNews } from '@@/server/types/common'

const route = useRoute()

const {
  countNews,
  currentPage,
  countElementsOnPage,
  countPages,
  onChangeCurrentPage,
} = useNewsPagination()

const { $host } = useNuxtApp()

const { data: news } = await useNuxtApi<MainPageNews>('/api/news/list', {
  query: { page: currentPage, size: countElementsOnPage },
  watch: [currentPage],
})

countNews.value = news.value?.count || 1

const title = 'Новости - Farfor'
const description =
  'Важные новости и приятные акции от доставки суши и пиццы Farfor: узнавайте больше, заказывайте чаще'

useHead({
  title,
  ...SEOMaker(
    $host,
    {
      title,
      keywords: '',
      description,
    },
    route.fullPath,
    route.path,
  ),
})
</script>

<template>
  <div class="news-page">
    <h1 class="news-page__title">Новости</h1>

    <the-news-list
      :news-list="news?.results"
      :current-page="currentPage"
      :count-pages="countPages"
      @update:model-value="onChangeCurrentPage($event)"
    />
  </div>
</template>

<style lang="scss" scoped>
.news-page {
  padding: 0 20px;
  padding-top: 45px; // 45 отступ сверху

  &__title {
    margin-bottom: 40px;
    font-size: 24px;
    font-weight: 800;
    color: var(--ui-color-white);
  }

  @include media($bp-tablet) {
    padding: 0 48px;
    padding-top: 80px; // отступ сверху

    &__title {
      font-size: 40px;
    }
  }

  @include media($bp-desktop-mini) {
    padding: 0;
    padding-top: 40px; // 40 отступ сверху
  }
}
</style>
